import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';
import {Button, Grid, Space, theme, Typography} from 'antd';

interface ShellProps {
  title: string | React.ReactNode;
  actionButtons?: JSX.Element[];
  children?: React.ReactNode;
  backLink?: boolean | string;
}

export const Shell: React.FC<ShellProps> = ({title, actionButtons, backLink, children}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {token} = theme.useToken();

  const {md, lg, xl, xxl} = Grid.useBreakpoint();

  const isMobile = !md && !lg && !xl && !xxl;

  return (
    <div className="max-w-7xl mx-auto">
      <div className={backLink ? 'visible' : 'invisible'}>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => backLink && (typeof backLink === 'boolean' ? navigate(-1) : navigate(backLink))}
          style={{color: token.colorTextDescription}}
          className="px-0"
        >
          {t('Back')}
        </Button>
      </div>
      <Space direction="vertical" size="large" className="flex justify-between">
        <Space className="flex justify-between">
          <Typography.Title level={isMobile ? 3 : 2}>{title}</Typography.Title>
          <Space>{actionButtons?.map((button) => button)}</Space>
        </Space>
        <main>{children}</main>
      </Space>
    </div>
  );
};
